import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    yourCompany: {
        id: '_.your_company.title',
        defaultMessage: 'Profile'
    },
    companyDetailsTitle: {
        id: '_.your_company.company_details.title',
        defaultMessage: 'Details'
    },
    companyDetailsSubtitle: {
        id: '_.your_company.company_details.subtitle',
        defaultMessage: 'Edit my company details'
    },
    peopleTitle: {
        id: '_.your_company.people.title',
        defaultMessage: 'People'
    },
    peopleSubtitle: {
        id: '_.your_company.people.subtitle',
        defaultMessage:
            'Add details of directors, shareholders or other people involved in your company'
    },
    paymentDetailsTitle: {
        id: '_.your_company.payment_details.title',
        defaultMessage: 'Payment Details'
    },
    paymentDetailsSubtitle: {
        id: '_.your_company.payment_details.subtitle',
        defaultMessage:
            'To complete your profile, you just need to add your business bank details so we know which account to fund and your debit card details, so we know which card to take your scheduled repayments from.'
    },
    paymentDetailsAnotherSubtitle: {
        id: '_.your_company.payment_details.another_subtitle',
        defaultMessage:
            'Wenn Sie ein aktives Lastschriftmandat haben brauchen Sie nichts weiter zu tun. Die vereinbarte Rate wird automatisch eingezogen.'
    },
    accountDetailsTitle: {
        id: '_.your_company.account_details.title',
        defaultMessage: 'Your account info'
    }
});
